import React, { useEffect, useContext, useState, useMemo } from 'react'
import { useLocation } from '@reach/router'
import { X } from 'phosphor-react'
import { Helmet } from 'react-helmet'
import { useQueryParam } from 'gatsby-query-params'
import { Script } from 'gatsby'
import Navbar from './Navbar'
import Footer from './Footer'
import QuoteFormContext from '../context/QuoteFormContext'
import QuoteForm from '../forms/QuoteForm'
import GovermentFleetForm from '../forms/GovernmentFleetForm'
import CommercialQuoteFrom from '../forms/CommercialQuoteForm'
import '@wordpress/block-library/build-style/style.css'
import '@wordpress/block-library/build-style/theme.css'
import '@wordpress/block-library/build-style/common.css'
import SlideMenu from './SlideMenu'
import SouthwestQuoteFrom from '../forms/SouthwestQuoteForm'
import QuoteFormRecaptcha from '../forms/QuoteFormRecaptcha'
import EarlyLeaseTerminationProgramForm from '../forms/EarlyLeaseTerminationProgramForm'

const quoteFormTypes = {
  default: 'default',
  government: 'government',
  commercial: 'commercial',
  southwest: 'southwest',
  recaptcha: 'recaptcha',
  earlylease: 'earlylease',
  earlyleaseexisting: 'earlyleaseexisting',
}

const quoteForms = {
  default: <QuoteForm />,
  government: <GovermentFleetForm />,
  commercial: <CommercialQuoteFrom />,
  southwest: <SouthwestQuoteFrom />,
  recaptcha: <QuoteFormRecaptcha />,
  earlylease: <EarlyLeaseTerminationProgramForm type="default"/>,
  earlyleaseexisting: <EarlyLeaseTerminationProgramForm type="existing"/>,
}

const TemplateWrapper = ({ children }) => {
  const { toggleModal, open } = useContext(QuoteFormContext)
  const [quoteFormType, setQuoteFormType] = useState(quoteFormTypes.default)
  const location = useLocation()
  const disableHeaderFooter = location?.pathname === '/4fi/';

  const gclid = useQueryParam('gclid')

  const htmlToElement = html => {
    var template = document.createElement('template')
    html = html.trim() // Never return a text node of whitespace as the result
    template.innerHTML = html
    return template.content.firstChild
  }

  const changeQuoteFormType = (type) => {
    setQuoteFormType(type);
    return true;
  }

  useEffect(() => {
    if (typeof window !== 'undefined') {
      localStorage.setItem('gclid', gclid)
    }
  }, [gclid])

  /**
   * Show modal when clicking on .type-deals container.
   */
  useEffect(() => {

    let clickCount = 0;

    const clickQuoteFormContainer = function (e) {
      clickCount++;

      // Bypass modal if we're clicking directly on the title link.
      const href = e.target.href ?? null;
      if (
        href &&
        href.includes('/car-lease-deals') &&
        !href.includes('#quoteForm')
      ) {
        return true;
      }

      // Attempt to resolve Car Title.
      let carName = '';
      const postBlock = e.target.closest('.wp-block-post');
      if (postBlock) {
        const title = postBlock.querySelector('.wp-block-post-title');
        if (title) {
          carName = title.textContent;
        }
      }

      // Add car title resolution to deal-singular page.
      if (
        '' === carName &&
        window.location.href.includes('/car-lease-deals/')
      ) {
        const firstH1 = document.querySelector('main h1.tracking-widest');
        if (firstH1) {
          carName = firstH1.textContent;
        }
      }

      // Find wanted car input.
      const wantedCarInput = document.querySelectorAll('.quote-modal input[name="wanted-car"]');
      if (wantedCarInput && wantedCarInput.length) {
        wantedCarInput.forEach(input => input.value = carName);
      }

      e.preventDefault();
      if (1 === clickCount) {
        toggleModal(true)
      }
    };

    const el = document.querySelectorAll('.type-deals, a[href="#quoteForm"]');

    if (!el || !el.length) {
      return;
    }

    el.forEach(node => {
      node.addEventListener('click', clickQuoteFormContainer);
    });

    return () => {
      el.forEach(node => {
        node.removeEventListener('click', clickQuoteFormContainer);
      });
    }
  });

  useEffect(() => {
    const handleClick = e => {
      const { target } = e
      const parentWrapper = target.parentElement

      // if (['#quoteForm', '/#quoteForm'].includes(target.getAttribute('href'))) {
      //   e.preventDefault()
      //   toggleModal()
      // }

      if (!parentWrapper) {
        return
      }

      if (parentWrapper.classList.contains('pixel-tag')) {
        if (parentWrapper.classList.contains('pixel-tag-send')) {
          const newEl = htmlToElement(
            location.pathname.includes('mid-size')
              ? '<img height="1" width="1" style="border-style:none;" alt="" src="https://insight.adsrvr.org/track/pxl/?adv=mbu4h7c&ct=0:yk4wzcp&fmt=3"/>'
              : '<img height="1" width="1" style="border-style:none;" alt="" src="https://insight.adsrvr.org/track/pxl/?adv=mbu4h7c&ct=0:a020nbv&fmt=3"/>'
          )
          document.body.insertBefore(newEl, document.body.firstChild)
        } else if (parentWrapper.classList.contains('pixel-tag-1')) {
          const newEl = htmlToElement(
            '<img height="1" width="1" style="border-style:none;" alt="" src="https://insight.adsrvr.org/track/pxl/?adv=mbu4h7c&ct=0:3i8i9ui&fmt=3"/>'
          )
          document.body.insertBefore(newEl, document.body.firstChild)
        } else if (parentWrapper.classList.contains('pixel-tag-3')) {
          const newEl = htmlToElement(
            '<img height="1" width="1" style="border-style:none;" alt="" src="https://insight.adsrvr.org/track/pxl/?adv=mbu4h7c&ct=0:gl0179o&fmt=3"/>'
          )
          document.body.insertBefore(newEl, document.body.firstChild)
        } else if (parentWrapper.classList.contains('pixel-tag-4')) {
          const newEl = htmlToElement(
            '<img height="1" width="1" style="border-style:none;" alt="" src="https://insight.adsrvr.org/track/pxl/?adv=mbu4h7c&ct=0:ilwaihh&fmt=3"/>'
          )
          document.body.insertBefore(newEl, document.body.firstChild)
        } else if (parentWrapper.classList.contains('pixel-tag-5')) {
          const newEl = htmlToElement(
            '<img height="1" width="1" style="border-style:none;" alt="" src="https://insight.adsrvr.org/track/pxl/?adv=mbu4h7c&ct=0:iy3kfsg&fmt=3"/>'
          )
          document.body.insertBefore(newEl, document.body.firstChild)
        } else if (parentWrapper.classList.contains('pixel-tag-6')) {
          const newEl = htmlToElement(
            '<img height="1" width="1" style="border-style:none;" alt="" src="https://insight.adsrvr.org/track/pxl/?adv=mbu4h7c&ct=0:p6zbj8o&fmt=3"/>'
          )
          document.body.insertBefore(newEl, document.body.firstChild)
        } else if (parentWrapper.classList.contains('pixel-tag-7')) {
          const newEl = htmlToElement(
            '<img height="1" width="1" style="border-style:none;" alt="" src="https://insight.adsrvr.org/track/pxl/?adv=mbu4h7c&ct=0:w8m0d7v&fmt=3"/>'
          )
          document.body.insertBefore(newEl, document.body.firstChild)
        } else if (parentWrapper.classList.contains('pixel-tag-9')) {
          const newEl = htmlToElement(
            '<img height="1" width="1" style="border-style:none;" alt="" src="https://insight.adsrvr.org/track/pxl/?adv=mbu4h7c&ct=0:z7q0gya&fmt=3"/>'
          )
          document.body.insertBefore(newEl, document.body.firstChild)
        }
      }
    }
    document.addEventListener('click', handleClick)

    return () => {
      document.removeEventListener('click', handleClick)
    }
  }, [])

  useEffect(() => {
    let isCanceled = false

    if (!isCanceled) {
      const path = location.pathname
      let changedFormType = false; 

      if (!changedFormType && path.includes('government')) {
        changedFormType = changeQuoteFormType(quoteFormTypes.government)
      }

      if (!changedFormType && path.includes('commercial-auto-lease')) {
        changedFormType = changeQuoteFormType(quoteFormTypes.commercial)
      }

      if (!changedFormType && path.includes('southwest-airlines')) {
        changedFormType = changeQuoteFormType(quoteFormTypes.southwest)
      }

      if (!changedFormType && path.includes('dm-early-lease-termination-program')) {
        changedFormType = changeQuoteFormType(quoteFormTypes.earlyleaseexisting)
      }

      if (!changedFormType && path.includes('early-lease')) {
        changedFormType = changeQuoteFormType(quoteFormTypes.earlylease)
      }

      if (!changedFormType) {
        // check if recaptcha endpoint works as expected 
        fetchData().then(response => {
          //alert(response);
          if (response) {
            setQuoteFormType(quoteFormTypes.recaptcha)
          }
        })
      }
    }

    return () => {
      isCanceled = true
    }
  }, [location])

  async function fetchData() {
    try {
      const response = await fetch(`/api/quote-form`)
      if (response.ok) {
        // Carry on...
        console.log('All good ✅')
      } else {
        throw response.status
      }
    } catch (e) {
      // Handle error
      //alert(e)
      if (e === 400) {
        return true
      } else {
        return false
      }
    }
  }

  const formHeader = useMemo(() => {
    // eslint-disable-next-line no-nested-ternary
    return quoteFormType === quoteFormTypes.government
      ? 'FREE GOVERNMENT FLEET SERVICE QUOTE.'
      : quoteFormType === quoteFormTypes.commercial
      ? 'FREE COMMERCIAL QUOTE.'
      : 'FREE AUTO LEASE QUOTE.'
  }, [quoteFormType])

  return (
    <div id="page-wrap">
      <Script src="https://cdn.complyauto.com/cookiebanner/banner/9586dc99-4de7-4e74-be0e-0ea8904a37d9/blocker.js" />
      <Script
        src="https://cdn.complyauto.com/cookiebanner/banner.js"
        data-cacookieconsent-id="9586dc99-4de7-4e74-be0e-0ea8904a37d9"
      />
      <Helmet
        title="..."
        meta={[
          { name: 'description', content: '...' },
          { name: 'keywords', content: '....' },
        ]}
        link={[
          {
            rel: 'shortcut icon',
            type: 'image/png',
            href: `/favicon.png`,
          },
        ]}
      />
      <Script
        dangerouslySetInnerHTML={{
          __html: `
            window.referralJS = ((window.referralJS !== null && window.referralJS !== undefined) ? window.referralJS : {});
            window.referralJS.scriptConfig = { parameters: { 
              src: "//refer-a-friend.4fi.com/ReferralSdk/referral.js", 
              transactionKey: "9faf4936-371d-4c73-b000-032cbe7f2a1b" 
            } };
            
            (function(f,r,n,d,b,y){
              b=f.createElement(r),
              y=f.getElementsByTagName(r)[0];
              b.async=1;
              b.src=n+"?referrer="+encodeURIComponent(window.location.origin+window.location.pathname).replace(/[!'()*]/g,escape);
              b.id="RR_DIVID_V5";
              b.setAttribute("transactionKey", window.referralJS.scriptConfig.parameters.transactionKey);
              y.parentNode.insertBefore(b,y);
            })(document,"script",window.referralJS.scriptConfig.parameters.src);
          `,
        }}
      />
      <Helmet>
        <script async="async" src="https://static.srcspot.com/libs/dorry.js" type="application/javascript"></script>
      </Helmet>
      <SlideMenu />
      <div
        className={`${
          open
            ? `opacity-1 pointer-events-auto z-50`
            : 'opacity-0 pointer-events-none'
        } transition-all fixed h-screen inset-0 bg-black bg-opacity-70 flex justify-center items-center pt-8 px-8 md:px-8  overflow-x-hidden overflow-y-auto quote-modal`}
      >
        <div className="relative w-full max-w-2xl px-4 h-full md:h-auto">
          <div className="max-w-2xl w-full relative">
            <div className="-right-8 top-0 absolute">
              <X
                color="white"
                size={24}
                className="cursor-pointer"
                onClick={() => toggleModal()}
              />
            </div>

            <div className="bg-brand-blue w-full rounded-t py-2 px-8 text-center">
              <h4 className="font-thin text-lg md:text-3xl text-white rounded-b">
                {formHeader}
              </h4>
              <h4 className="font-thin text-lg md:text-3xl text-white">
                ANY MAKE, ANY MODEL.
              </h4>
            </div>

            <div className="bg-white py-2 px-2 md:px-8">
              <p className="text-center max-w-sm mx-auto">
                Simply fill out the brief form below to receive a free quote
                today. No obligations.
              </p>
              {quoteForms[quoteFormType]}
            </div>
          </div>
        </div>
      </div>
      {
        !disableHeaderFooter && <Navbar />
      }
      <main className={open && 'pointer-events-none'}>{children}</main>
      {
        !disableHeaderFooter && <Footer />
      }
    </div>
  )
}

export default TemplateWrapper
